import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowTriangleLeft"><Path d="M19.5 19.5V4.5L4.5 12L19.5 19.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleLeft;
